/**
 * affordabilityAgent.js
 * Async helpers for the Affordability Calculator feature.
 * Simple request functions — no hooks needed.
 */

import APIAgent from './apiAgent';

// ---------------------------------------------------------------------------
// calculateAffordability — compute monthly payment breakdown
// ---------------------------------------------------------------------------
export async function calculateAffordability(data) {
  return APIAgent.request('/api/affordability/calculate', 'POST', data);
}

// ---------------------------------------------------------------------------
// compareScenarios — compare multiple down-payment / rate scenarios
// ---------------------------------------------------------------------------
export async function compareScenarios(data) {
  return APIAgent.request('/api/affordability/compare-scenarios', 'POST', data);
}

// ---------------------------------------------------------------------------
// getAmortization — full amortization schedule
// ---------------------------------------------------------------------------
export async function getAmortization(data) {
  return APIAgent.request('/api/affordability/amortization', 'POST', data);
}
